module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "head-title-right"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3874ffca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/title/src/Title.vue
// module id = 1210
// module chunks = 2